module.exports = __webpack_public_path__ + "static/testimonial-repobox-jimmy-9ceae61ab63c0a310e5caf60788877dc.jpeg";